import { AxiosError } from "axios";
import http from "infra/http";
import { useMutation } from "react-query";
import { AnimalForm } from "../typings";

export function useCriarEditarAnimal() {
  return useMutation<{ success: boolean }, AxiosError, AnimalForm & {id?: string; unidadeId: string}>(
    async (form: AnimalForm & {id?: string; unidadeId: string}) => {
      const formData = new FormData();

      form.foto && formData.append('foto', form.foto);      
      form.cartaoVacina && formData.append('cartaoVacina', form.cartaoVacina);
      form.cor && formData.append('cor', form.cor);
      form.dataNascimento && formData.append('dataNascimento', form.dataNascimento);
      form.nome && formData.append('nome', form.nome);
      form.porte && formData.append('porte', form.porte);
      form.tipoAnimalId && formData.append('tipoAnimalId', form.tipoAnimalId);
      form.observacao && formData.append('observacao', form.observacao);
      form.docio !== undefined && formData.append('docio', JSON.stringify(form.docio));
      form.unidadeId && formData.append('unidadeId', form.unidadeId);


      if (form.id) {
        const {data} = await http.put<{success: boolean}>(`/v1/animal/${form.id}`, formData)

        return data;
      }

      const {data} = await http.post<{success: boolean}>('/v1/animal', formData)

      return data;
    },
    {
      retry: false,
    }
  );
}
